/* !
 * index.js v1.0.0
 * Copyright, Connecty Inc.
 */
((FUNCTIONS) => {
	const a = 'is-active';
	const v = 'is-visible';

	// バイト数を単位付きの文字列に変換する関数
	const formatFileSize = (bytes) => {
		const num = Number(bytes);
		if (isNaN(num) || num === 0) return '0Bytes';
		const units = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
		const i = Math.floor(Math.log(num) / Math.log(1024));
		const index = Math.min(i, units.length - 1);
		const size = (num / Math.pow(1024, index)).toFixed(1).replace(/\.0$/, '');
		return size + units[index];
	};

	const dropDown = () => {
		if(document.querySelector('.js-news-yearList')) {
			let allNewsData = []; // 全ニュースデータを保持
			let templateClone = null; // テンプレートを保持
			let parentElement = null; // 親要素を保持
			let currentCategory = 'all'; // 現在選択中のカテゴリ
			let currentPage = 1; // 現在のページ
			let isAllNewsSorted = false; // 全件データのソート状態
			let activeFetchController = null; // 進行中fetchの制御
			let loadingCount = 0; // JSON処理中カウント
			const newsJsonCache = new Map(); // JSONレスポンスキャッシュ
			const itemsPerPage = 10; // 1ページあたりの表示件数
			const newsLoading = document.querySelector('.js-newsLoading');

			if (newsLoading) {
				newsLoading.classList.add('is-anim');
			}

			const startNewsLoading = () => {
				loadingCount += 1;
				if (!newsLoading) return;
				newsLoading.classList.add(a);
				newsLoading.classList.remove('is-loaded');
			};

			const finishNewsLoading = () => {
				loadingCount = Math.max(loadingCount - 1, 0);
				if (!newsLoading || loadingCount > 0) return;
				newsLoading.classList.remove(a);
				newsLoading.classList.add('is-loaded');
			};

			// 現在のパスからJSONベースパスを決定
			const currentPath = location.pathname;
			let jsonBasePath = '';
			if (currentPath.includes('/sustainability/csr/sponsor/')) {
				jsonBasePath = '/ajax/scr/news/';
			} else if (currentPath.includes('/news/')) {
				jsonBasePath = '/ajax/news/';
			}

			// JSONパスを生成する関数
			const getJsonPath = (year) => {
				if (year === 'latest' || year === '') {
					// 最新（全件）の場合
					return `${jsonBasePath}list.json`;
				} else {
					// 特定の年度の場合
					return `${jsonBasePath}${year}/list.json`;
				}
			};

			// 最新と最古の年を取得
			const latest = document.querySelector('.js-news-latest-year').textContent;
			const earliest = document.querySelector('.js-news-earliest-year').textContent;

			// ドロップダウンリスト要素を取得
			const yearList = document.querySelector('.js-news-yearList');

			// ニュースリストをソートする関数（優先度1を先頭に、日付降順）
			const sortNewsList = (data) => {
				return data.slice().sort((a, b) => {
					// まずpriorityで比較（1が優先）
					if (Number(a.cf_n_priority) === 1 && Number(b.cf_n_priority) !== 1) {
						return -1; // aを前に
					}
					if (Number(a.cf_n_priority) !== 1 && Number(b.cf_n_priority) === 1) {
						return 1; // bを前に
					}
					// priority が同じ場合は、日付で比較（新しい順）
					const dateA = Date.parse(a.cf_n_date) || 0;
					const dateB = Date.parse(b.cf_n_date) || 0;
					return dateB - dateA; // 降順
				});
			};

			const fetchNewsData = (jsonPath) => {
				if (newsJsonCache.has(jsonPath)) {
					return Promise.resolve(newsJsonCache.get(jsonPath));
				}
				if (activeFetchController) {
					activeFetchController.abort();
				}
				const controller = new AbortController();
				activeFetchController = controller;
				startNewsLoading();
				return fetch(jsonPath, { signal: controller.signal })
					.then(response => response.json())
					.then((data) => {
						newsJsonCache.set(jsonPath, data);
						return data;
					})
					.finally(() => {
						if (activeFetchController === controller) {
							activeFetchController = null;
						}
						finishNewsLoading();
					});
			};

			// ニュースリストを描画する関数
			const renderNewsList = (filteredData, page = 1) => {
				const wrapper = document.querySelector('.js-news-list-wrap');

				if (!parentElement) return;

				// 既存の全アイテムを削除
				parentElement.textContent = '';

				// 既存のメッセージを削除
				if (wrapper) {
					const existingMessage = wrapper.querySelector('.js-news-list-empty');
					if (existingMessage) {
						existingMessage.remove();
					}
				}

				// フィルタリングされたデータがない場合
				if (!filteredData || filteredData.length === 0) {
					if (wrapper) {
						const message = document.createElement('p');
						message.className = 'js-news-list-empty';
						message.textContent = '該当するニュースはございません';
						wrapper.prepend(message);
					}
					// ページネーションを削除
					removePagination();
					return;
				}

				// ページネーション用の計算
				const totalItems = filteredData.length;
				const totalPages = Math.ceil(totalItems / itemsPerPage);
				const startIndex = (page - 1) * itemsPerPage;
				const endIndex = Math.min(startIndex + itemsPerPage, totalItems);
				const pageData = filteredData.slice(startIndex, endIndex);
				const fragment = document.createDocumentFragment();
				const isSponsorPath = location.pathname.includes('/sustainability/csr/sponsor/');
				const newlineRegex = /\n/g;

				// 各ニュースアイテムを生成
				for (let i = 0; i < pageData.length; i++) {
					const item = pageData[i];
					const newElement = templateClone.cloneNode(true);

					// タイトル
					const titleElement = newElement.querySelector('.js-news-list-title');
					if (titleElement) {
						titleElement.innerHTML = item.cf_n_title.replace(newlineRegex, '<br>');
					}

					// カテゴリ名
					const categoryElement = newElement.querySelector('.js-news-list-category');
					if (categoryElement && item.cf_n_category) {
						categoryElement.textContent = item.cf_n_category.cf_nc_name_ja;
					}

					// 日付
					const timeElement = newElement.querySelector('.js-news-list-time');
					if (timeElement && item.cf_n_date) {
						const date = new Date(item.cf_n_date);
						const mm = String(date.getMonth() + 1).padStart(2, '0');
						const dd = String(date.getDate()).padStart(2, '0');
						const yyyy = date.getFullYear();
						timeElement.textContent = `${yyyy}.${mm}.${dd}`;
						timeElement.setAttribute('datetime', `${yyyy}-${mm}-${dd}`);
					}

					// 選手名
					const playerElement = newElement.querySelector('.js-news-list-player');
					if (playerElement) {
						if (item.cf_n_sub_title) {
							playerElement.textContent = item.cf_n_sub_title;
							playerElement.style.display = '';
						} else {
							playerElement.style.display = 'none';
						}
					}

					// サムネイル画像
					const imgElement = newElement.querySelector('.js-news-list-img');
					if (imgElement && item.cf_n_thum_img) {
						imgElement.src = `./news_file/file/${item.cf_n_thum_img}`;
						imgElement.alt = item.cf_n_thum_img_alt || '';
						imgElement.title = item.cf_n_thum_img_title || '';
					} else {
						const imgWrap = newElement.querySelector('.js-news-list-img-wrap');
						if (imgWrap) {
							imgWrap.style.display = 'none';
						}
					}

					// リンク設定
					const linkElement = newElement.querySelector('.js-news-list-link');
					if (linkElement) {
						const cf_n_type = Number(item.cf_n_type);

						// 既存のアイコンを削除
						const existingIcon = linkElement.querySelector('.__icon');
						if (existingIcon) {
							existingIcon.remove();
						}

						switch(cf_n_type) {
							case 1:
								// /sustainability/csr/sponsor/参照時は専用パス
								if (isSponsorPath) {
									linkElement.href = `/sustainability/csr/sponsor/article/${item._key}.html`;
								} else if (item.cf_n_topicks_newslist === 1) {
									linkElement.href = `/news/topics/article/${item._key}.html`;
								} else {
									linkElement.href = `/news/article/${item._key}.html`;
								}
								break;
							case 2:
								linkElement.href = `/news/news_file/file/${item.cf_n_attachment_file}`;
								linkElement.setAttribute('target', '_blank');
								const ttlElement = linkElement.querySelector('.__ttl');
								if (ttlElement) {
									const isPDF = item.cf_n_attachment_file && item.cf_n_attachment_file.toLowerCase().endsWith('.pdf');
									const hasFileSize = item.cf_n_attachment_file_size;
									if (isPDF && hasFileSize) {
										const iconHTML = `<span class="__icon"><svg aria-label="新しいウィンドウでPDFを開きます"><use href="/cnt_common/svg/sprite.svg#pdf"></use></svg><span class="__file">（<span class="js-fileSize">${formatFileSize(item.cf_n_attachment_file_size)}</span>）</span></span>`;
										ttlElement.insertAdjacentHTML('beforeend', iconHTML);
									} else {
										const iconHTML = `<span class="__icon"><svg aria-label="新しいウィンドウで開きます"><use href="/cnt_common/svg/sprite.svg#blank"></use></svg></span>`;
										ttlElement.insertAdjacentHTML('beforeend', iconHTML);
									}
								}
								break;
							case 3:
								linkElement.href = item.cf_n_url;
								const isExternalLink = /^https?:\/\//.test(item.cf_n_url);
								if (isExternalLink) {
									linkElement.setAttribute('target', '_blank');
									const ttlElement3 = linkElement.querySelector('.__ttl');
									if (ttlElement3) {
										const iconHTML = `<span class="__icon"><svg aria-label="新しいウィンドウで開きます"><use href="/cnt_common/svg/sprite.svg#blank"></use></svg></span>`;
										ttlElement3.insertAdjacentHTML('beforeend', iconHTML);
									}
								} else {
									linkElement.setAttribute('target', '_self');
								}
								break;
							case 4:
								linkElement.href = '#';
								linkElement.style.pointerEvents = 'none';
								linkElement.style.cursor = 'default';
								linkElement.style.textDecoration = 'none';
								linkElement.classList.add('rt_cf_nolink');
								break;
							case 5:
								linkElement.href = '#';
								linkElement.style.pointerEvents = 'none';
								linkElement.style.cursor = 'default';
								linkElement.style.textDecoration = 'none';
								linkElement.classList.add('rt_cf_nolink');
								break;
						}
					}

					fragment.appendChild(newElement);
				}

				// 親要素にまとめて追加
				parentElement.appendChild(fragment);

				// ページネーションを表示
				renderPagination(totalPages, page);
			};

			// ページネーションを削除する関数
			const removePagination = () => {
				const paginationContainer = document.querySelector('.mod-paginate');
				if (paginationContainer) {
					paginationContainer.remove();
				}
			};

			// ページネーションを描画する関数
			const renderPagination = (totalPages, currentPageNum) => {
				// 既存のページネーションを削除
				removePagination();
				// 10件以内の場合はページネーションを表示しない
				if (totalPages <= 1) {
					return;
				}
				// ページネーションのHTMLを生成
				const paginationHTML = document.createElement('div');
				paginationHTML.className = 'mod-paginate mod-spacer_16';
				// 最初へボタン（3ページ以上の場合、かつ1ページ目でない場合のみ表示）
				if (totalPages >= 3 && currentPageNum > 1) {
					const firstBtn = document.createElement('button');
					firstBtn.type = 'button';
					firstBtn.className = 'mod-paginate-prev02 js-page-most-first';
					firstBtn.setAttribute('aria-label', '先頭のページへ');
					firstBtn.innerHTML = '<svg aria-hidden="true"><use href="/cnt_common/svg/sprite.svg#arrow_left_double"></use></svg>';
					firstBtn.addEventListener('click', () => goToPage(1));
					paginationHTML.appendChild(firstBtn);
				}
				// 前へボタン（1ページ目でない場合のみ表示）
				if (currentPageNum > 1) {
					const prevBtn = document.createElement('button');
					prevBtn.type = 'button';
					prevBtn.className = 'mod-paginate-prev js-page-prev';
					prevBtn.setAttribute('aria-label', '前のページへ');
					prevBtn.innerHTML = '<svg aria-hidden="true"><use href="/cnt_common/svg/sprite.svg#arrow_left"></use></svg>';
					prevBtn.addEventListener('click', () => goToPage(currentPageNum - 1));
					paginationHTML.appendChild(prevBtn);
				}
				// ページ番号ボタン（最大5つ）
				const maxPageButtons = 5;
				let startPage = Math.max(1, currentPageNum - Math.floor(maxPageButtons / 2));
				let endPage = Math.min(totalPages, startPage + maxPageButtons - 1);
				// 右端に寄りすぎた場合は左にシフト
				if (endPage - startPage < maxPageButtons - 1) {
					startPage = Math.max(1, endPage - maxPageButtons + 1);
				}
				for (let i = startPage; i <= endPage; i++) {
					if (i === currentPageNum) {
						// カレントページはspanで表示
						const currentSpan = document.createElement('span');
						currentSpan.className = 'mod-paginate-index js-page-index';
						currentSpan.textContent = i;
						paginationHTML.appendChild(currentSpan);
					} else {
						// その他はボタンで表示
						const pageBtn = document.createElement('button');
						pageBtn.type = 'button';
						pageBtn.className = 'mod-paginate-index js-page-indexs';
						pageBtn.textContent = i;
						pageBtn.addEventListener('click', () => goToPage(i));
						paginationHTML.appendChild(pageBtn);
					}
				}
				// 次へボタン（最後のページでない場合のみ表示）
				if (currentPageNum < totalPages) {
					const nextBtn = document.createElement('button');
					nextBtn.type = 'button';
					nextBtn.className = 'mod-paginate-next js-page-next';
					nextBtn.setAttribute('aria-label', '次のページへ');
					nextBtn.innerHTML = '<svg aria-hidden="true"><use href="/cnt_common/svg/sprite.svg#arrow_right"></use></svg>';
					nextBtn.addEventListener('click', () => goToPage(currentPageNum + 1));
					paginationHTML.appendChild(nextBtn);
				}
				// 最後へボタン（カレントページが最後でない場合のみ表示）
				if (currentPageNum < totalPages) {
					const lastBtn = document.createElement('button');
					lastBtn.type = 'button';
					lastBtn.className = 'mod-paginate-next02 js-page-most-last';
					lastBtn.setAttribute('aria-label', '最後のページへ');
					lastBtn.innerHTML = '<svg aria-hidden="true"><use href="/cnt_common/svg/sprite.svg#arrow_right_double"></use></svg>';
					lastBtn.addEventListener('click', () => goToPage(totalPages));
					paginationHTML.appendChild(lastBtn);
				}
				// ページネーションを挿入
				const wrapper = document.querySelector('.js-news-list-wrap');
				if (wrapper) {
					wrapper.appendChild(paginationHTML);
				}
			};

			// 指定ページに移動する関数
			const goToPage = (page) => {
				const totalPages = Math.ceil(allNewsData.length / itemsPerPage);
				// ページ番号の範囲チェック
				if (page < 1 || page > totalPages) {
					return;
				}
				if (!isAllNewsSorted) {
					allNewsData = sortNewsList(allNewsData);
					isAllNewsSorted = true;
				}
				currentPage = page;
				renderNewsList(allNewsData, currentPage);
				// #news-topにスクロール
				const newsTop = document.querySelector('#news-top');
				if (newsTop) {
					const targetPosition = newsTop.getBoundingClientRect().top + window.pageYOffset - 100;
					window.scrollTo({ top: targetPosition, behavior: 'smooth' });
				}
			};

			// カテゴリフィルタリング関数（JSONを取得）
			const filterByCategory = (categoryCode, year) => {
				currentCategory = categoryCode;
				currentPage = 1; // ページをリセット
				// 年度が指定されていない場合は、現在選択中の年度を使用
				const selectedYear = year || yearList.value || 'latest';
				// カテゴリごとのJSONパスを決定
				let categoryJsonPath = '';
				if (categoryCode === 'all') {
					// 全ての場合は、年度のJSONを使用
					categoryJsonPath = getJsonPath(selectedYear);
				} else {
					// 特定カテゴリの場合
					if (selectedYear === 'latest' || selectedYear === '') {
						// 最新の場合：カテゴリのみ
						categoryJsonPath = `${jsonBasePath}${categoryCode}/list.json`;
					} else {
						// 年度指定の場合：年度＋カテゴリ
						categoryJsonPath = `${jsonBasePath}${selectedYear}/${categoryCode}/list.json`;
					}
				}
				// JSONを取得して表示
				fetchNewsData(categoryJsonPath)
				.then((data) => {
					if (!data.rt_bn_news_list || data.rt_bn_news_list.length === 0) {
						allNewsData = [];
						isAllNewsSorted = true;
						renderNewsList([]);
						return;
					}
					// データを保存（優先度と日付でソート）
					allNewsData = sortNewsList(data.rt_bn_news_list);
					isAllNewsSorted = true;
					// 表示
					renderNewsList(allNewsData, currentPage);
				})
				.catch(error => {
					if (error.name === 'AbortError') return;
					console.error('カテゴリデータの取得に失敗しました:', error);
					allNewsData = [];
					isAllNewsSorted = true;
					renderNewsList([]);
				});
			};

			// 年度でフィルタリング（JSONを再取得）
			const filterByYear = (year) => {
				currentPage = 1; // ページをリセット
				// カテゴリが選択されている場合は、年度＋カテゴリのJSONを取得
				if (currentCategory !== 'all') {
					filterByCategory(currentCategory, year);
				} else {
					// カテゴリが全ての場合は、年度のみのJSONを取得
					const jsonPath = getJsonPath(year);
					fetchNewsData(jsonPath)
					.then((data) => {
						if (!data.rt_bn_news_list || data.rt_bn_news_list.length === 0) {
							allNewsData = [];
							isAllNewsSorted = true;
							renderNewsList([]);
							return;
						}
						// データを保存（優先度と日付でソート）
						allNewsData = sortNewsList(data.rt_bn_news_list);
						isAllNewsSorted = true;
						// 表示
						renderNewsList(allNewsData, currentPage);
					})
					.catch(error => {
						if (error.name === 'AbortError') return;
						console.error('ニュースデータの取得に失敗しました:', error);
						allNewsData = [];
						isAllNewsSorted = true;
						renderNewsList([]);
					});
				}
			};

			// カテゴリボタンのイベントリスナー設定
			const setupCategoryButtons = () => {
				const allButton = document.querySelector('.js-news-all');
				const tennisButton = document.querySelector('.js-news-tennis');
				const golfButton = document.querySelector('.js-news-golf');
				const figureSkateButton = document.querySelector('.js-news-figure-skate');
				const activitiesButton = document.querySelector('.js-news-activities');
				const informationButton = document.querySelector('.js-news-information');
				const productButton = document.querySelector('.js-news-product');
				const sportsButton = document.querySelector('.js-news-sports');
				const storeButton = document.querySelector('.js-news-store');
				const otherButton = document.querySelector('.js-news-other');
				const buttons = [allButton, tennisButton, golfButton, figureSkateButton, activitiesButton, informationButton, productButton, sportsButton, storeButton, otherButton];
				// アクティブ状態を切り替える関数
				const setActiveButton = (activeButton) => {
					buttons.forEach(button => {
						if (button) {
							button.classList.remove(a);
						}
					});
					if (activeButton) {
						activeButton.classList.add(a);
					}
				};
				if (allButton) {
					allButton.addEventListener('click', (e) => {
						e.preventDefault();
						setActiveButton(allButton);
						filterByCategory('all');
					});
				}
				if (tennisButton) {
					tennisButton.addEventListener('click', (e) => {
						e.preventDefault();
						setActiveButton(tennisButton);
						filterByCategory('sports_tennis');
					});
				}
				if (golfButton) {
					golfButton.addEventListener('click', (e) => {
						e.preventDefault();
						setActiveButton(golfButton);
						filterByCategory('sports_golf');
					});
				}
				if (figureSkateButton) {
					figureSkateButton.addEventListener('click', (e) => {
						e.preventDefault();
						setActiveButton(figureSkateButton);
						filterByCategory('sports_figure_skating');
					});
				}
				if (activitiesButton) {
					activitiesButton.addEventListener('click', (e) => {
						e.preventDefault();
						setActiveButton(activitiesButton);
						filterByCategory('activities');
					});
				}
				if (informationButton) {
					informationButton.addEventListener('click', (e) => {
						e.preventDefault();
						setActiveButton(informationButton);
						filterByCategory('information');
					});
				}
				if (productButton) {
					productButton.addEventListener('click', (e) => {
						e.preventDefault();
						setActiveButton(productButton);
						filterByCategory('product');
					});
				}
				if (sportsButton) {
					sportsButton.addEventListener('click', (e) => {
						e.preventDefault();
						setActiveButton(sportsButton);
						filterByCategory('sports');
					});
				}
				if (storeButton) {
					storeButton.addEventListener('click', (e) => {
						e.preventDefault();
						setActiveButton(storeButton);
						filterByCategory('store');
					});
				}
				if (otherButton) {
					otherButton.addEventListener('click', (e) => {
						e.preventDefault();
						setActiveButton(otherButton);
						filterByCategory('other');
					});
				}
			};

			const initDeferredUI = () => {
				// HTML側の既存の「最新」オプションに値を設定
				const existingOptions = yearList.querySelectorAll('option');
				existingOptions.forEach(option => {
					if (option.textContent.trim() === '最新' && option.value === '') {
						option.value = 'latest';
						option.selected = true;
					}
				});

				// 最新から最古の年までのオプションを生成し追加
				for(var i = latest; i >= earliest; i--) {
					const option = document.createElement('option');
					option.textContent = i.toString();
					option.value = i.toString();
					yearList.appendChild(option);
				}

				// カテゴリボタンのイベントリスナー設定
				setupCategoryButtons();
				// ドロップダウンリストの変更イベントを処理(ボタンの場合)
				const yearListSubmit = document.querySelector('.js-news-yearList-submit');
				if (yearListSubmit) {
					yearListSubmit.addEventListener('click', function () {
						const selectedYear = yearList.value;
						filterByYear(selectedYear);
					});
				}
			};

			// JSONデータを取得（初期表示）
			const initialJsonPath = getJsonPath('latest');
			fetchNewsData(initialJsonPath)
			.then((data) => {
				if (!data.rt_bn_news_list || data.rt_bn_news_list.length === 0) {
					const template = document.querySelector('.js-news-list');
					if (template) template.remove();
					isAllNewsSorted = true;
					return;
				}
				// テンプレートを保存
				const template = document.querySelector('.js-news-list');
				if (template) {
					templateClone = template.cloneNode(true);
					parentElement = template.parentElement;
					template.remove();
				}
				// 全データを保存（初期表示はソートを遅延）
				allNewsData = data.rt_bn_news_list.slice();
				isAllNewsSorted = false;
				// 初期表示（すべて表示）
				renderNewsList(allNewsData, currentPage);

				if (window.requestIdleCallback) {
					window.requestIdleCallback(initDeferredUI, { timeout: 300 });
				} else {
					setTimeout(initDeferredUI, 0);
				}
			})
			.catch(error => {
				if (error.name === 'AbortError') return;
				console.error('初期データの取得に失敗しました:', error);
			});
			// ドロップダウンリストの変更イベントを処理(プルダウンの場合)
			// yearList.addEventListener('change', function() {
			// 	const selectedYear = yearList.value;
			// 	filterByYear(selectedYear);
			// });
		}
	};

	// ニュースリストを描画（※ニュース描画が不要な案件では削除）
	// const createNews = async () => {
	// 	// htmlをテンプレートとして使用
	// 	let html = await fetch('/cnt_common/js/html/news-list.html').then(res => res.text());

	// 	fetch(cmsNewsJson())
	// 	.then(response => response.json())
	// 	.then((data) => {
	// 		const newsData = data.rt_bn_news;
	// 		if(newsData.length) {
	// 			for(let i=0; i<newsData.length; i++) {
	// 				let _title = newsData[i].rt_cf_n_title.content[0];
	// 				let _category = newsData[i].rt_cf_n_category_name.content[0];
	// 				let _date = newsData[i].rt_cf_n_date.content;
	// 				let _href = newsData[i].rt_cf_n_href;
	// 				let _hrefLink = _href.href;
	// 				let _target = _href.target;
	// 				let _pdf = newsData[i].rt_cf_n_attachment_file_icon_pdf;
	// 				let _pdfSize = newsData[i].rt_cf_n_attachment_file_size;
	// 				let icon = _pdf !== null ? pdfIcon : (_target === '_blank' ? blankIcon : '');
	// 				let pdfSpan = '';
	// 				if(_pdfSize !== null) {
	// 					pdfSpan = `<span class="__file">(PDF:<span class="">${bytesToSize(_pdfSize.content)}</span>)</span>`;
	// 				}

	// 				// UTCのまま出力されている場合はUTC→JSTに変換
	// 				// new Date(_date)

	// 				let isDisable = _hrefLink === '#' ? 'is-disable' : '';

	// 				let thisHtml = html
	// 					.replaceAll('{!href!}', _hrefLink)
	// 					.replaceAll('{!target!}', _target)
	// 					.replaceAll('{!isDisable!}', isDisable)
	// 					.replaceAll('{!date!}', _date)
	// 					.replaceAll('{!category!}', _category)
	// 					.replaceAll('{!title!}', _title)
	// 					.replaceAll('{!pdfSize!}', pdfSpan)
	// 					.replaceAll('{!icon!}', icon)
	// 			}
	// 		}
	// 	});
	// }

	// ＝＝＝＝ ↑↑ FUNCTIONS ↑↑ ＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝

	const newsFUNCTIONS = () => {
		dropDown();
		// createNews(); // ニュース描画が不要な案件では削除
	};

	(FUNCTIONS.localDecision()) ? document.addEventListener('localincludeLoaded', () => { newsFUNCTIONS(); }) : newsFUNCTIONS();

})(window.FUNCTIONS);
